import { DrawerFilter, SubscriptionPlanName } from '../../../models';

export const companiesFilters = ({
  subscriptionPlans,
}: {
  subscriptionPlans: {
    value: number;
    text: SubscriptionPlanName;
  }[];
}): DrawerFilter[] => [
  {
    type: 'select',
    label: 'Subscription Plan',
    list: subscriptionPlans,
    value: subscriptionPlans[0].value,
    name: 'subscriptionPlan',
  },
];
